export function weightUnitSelect() {
  const gramButton = document.getElementById('unitGramButton');
  const ounceButton = document.getElementById('unitOunceButton');
  if (!gramButton || !ounceButton) return;

  let isGrams = true;

  function updateDisplay() {
    gramButton.toggleAttribute('data-selected', isGrams);
    ounceButton.toggleAttribute('data-selected', !isGrams);
    gramButton.setAttribute('aria-selected', isGrams);
    ounceButton.setAttribute('aria-selected', !isGrams);

    document.querySelectorAll('[data-unit]').forEach(el => {
      el.style.display = el.getAttribute('data-unit') === (isGrams ? 'gram' : 'ounce') ? 'inline' : 'none';
    });
  }

  gramButton.addEventListener('click', () => {
    isGrams = true;
    updateDisplay();
  });

  ounceButton.addEventListener('click', () => {
    isGrams = false;
    updateDisplay();
  });

  updateDisplay();
}
